
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/listing/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/marketplace/listing/[id]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/listing/[id]/[[...slug]]"])
      });
    }
  